import React, { Component } from "react";
import { Grid } from "@progress/kendo-react-grid";
import { orderBy, filterBy } from "@progress/kendo-data-query";
import { isEmpty /*, getExportFileName*/ } from "../helpers";
import PropTypes from "prop-types";
import { compose } from "redux";
import localize from "../hoc/localize";
import { defaultGridProperties } from "./utils/GridHelpers";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import Toolbar from "./Toolbar";
import ToolbarOption from "./ToolbarOption";
import { CSVLink } from "react-csv-3";
import isPage from "../hoc/isPage";
import { LocalizationProvider } from "@progress/kendo-react-intl";
import grid from "../localization/fr.json";
import { loadMessages } from "@progress/kendo-react-intl";
export class GridContainerToolbar extends Component { }
GridContainerToolbar.displayName = "GridContainerToolbar";
export class GridContainerToolbarOption extends Component { }
GridContainerToolbarOption.displayName = "GridContainerToolbarOption";
loadMessages(grid, "fr")

class GridContainer extends Component {
    _export;
    static propTypes = {
        data: PropTypes.array,

        // specify the default sort column.
        // if empty string, then grid will be sortable, but no column will be sorted by default.
        sortColumn: PropTypes.string,

        // enable pagination
        pageable: PropTypes.bool,
        buttonCount: PropTypes.number,
        pageSize: PropTypes.number,

        // enable filtering
        // (note: we're using an AND condition for the filtering; i.e. results displayed in grid satisfy all filters)
        filterable: PropTypes.bool,

        // parent-child config
        detail: PropTypes.func, // a React element that represents the child component for parent-child relationships
        onExpandChange: PropTypes.func,
        rowRender: PropTypes.func, // can be used to conditionally show the expand icon (based on whether child data is available or not)

        // export config
        // if downloadExcel or downloadCsv are set to true, then exportFilename MUST be specified
        excelFilename: PropTypes.string,
        csvFileName: PropTypes.string,
        csvData: PropTypes.array,
        // the referenceID to be logged
        referenceID: PropTypes.number,
        // indicate whether there is a summary line on the top
        hasSummaryLine: PropTypes.bool,
        // indicate whether there is a Show excluded parts checkbox in the summary line on the top
        hasShowExcludedParts: PropTypes.bool,
        // indicates whether an error message to save changes will pop up when exporting Excel file after the data has been modified.
        allowUnsavedExcelExport: PropTypes.bool,
    };
    state = {
        sort: [{ field: this.props.sortColumn, dir: "asc" }],
        skip: 0,
        take: this.props.pageSize ? this.props.pageSize : 10,
        pageSize: this.props.pageSize ? this.props.pageSize : 10,
        filter: {
            logic: "and",
            filters: [],
        },
        showExcludedParts: true,
        freshLoad: true,
        isNarrow: false,
        allowUnsavedExcelExport: this.props.allowUnsavedExcelExport ? this.props.allowUnsavedExcelExport : true,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.pageSize) {
            if (nextProps.pageSize !== prevState.pageSize) {
                return {
                    pageSize: nextProps.pageSize,
                    take: nextProps.pageSize,
                };
            }
        }
        return null;
    }

    //!DBTRANS! @m0023@ Error! !DEVNOTE! Error message
    //!DBTRANS! @m0024@ Please save changes before export. !DEVNOTE! Error reason

    exportExcel = () => {
        const updatedRecords = this.props.data.filter((i) => i.updated);
        if ((this.props.allowUnsavedExcelExport === undefined || !this.props.allowUnsavedExcelExport) && updatedRecords.length > 0) {
            this.props.errorAlert("m0024");
            return;
        }

        this._export.save(this.props.data);

        if (this.props.referenceID) {
            // 5: SuggestedPO Exported - XLS
            this.props
                .postData(
                    `/api/portal/admin/user/LogEvent/5/${this.props.referenceID}`
                )
                .catch((error) => {
                    this.props.alert(
                        "error",
                        this.props.returnLocalizedString("m0023"),
                        error.message
                    );
                });
        }
        // we need to export Order Qty and Adj Reason
        // this.props.data needs to be transformed so we can extract Adj Reason name.

        // new prop -
    };

    handleShowExcludedParts = () => {
        this.setState({
            showExcludedParts: !this.state.showExcludedParts,
        });
        //this.setState({
        //    showExcludedPartsFilter: {
        //        logic: "and",
        //        filters: [
        //            { field: "neverOrder", operator: "eq", value: true }
        //        ]
        //    }
        //});
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        //at 1500px, resize to ensure toolbar buttons do not overlap with other elements
        if (window.innerWidth < 1500) {
            this.setState({ isNarrow: true });
        }
        else {
            this.setState({ isNarrow: false });
        }
    };

    render() {
        //const toolbarOption = this.props.children;

        // check out what options the user wants
        let toolbarOptions = null;
        let toolbarChildren;

        // find out if the user has indicated he wants to add extra toolbar options
        //debugger;

        if (this.props.children) {
            // check if the parent toolbar element has been defined
            const toolbar = this.props.children
                .filter((child) => child !== undefined)
                .find(
                    (option) =>
                        option.type.displayName === "GridContainerToolbar"
                );

            // if parent toolbar exists, then get all the toolbar options (from children prop)
            if (toolbar) {
                toolbarChildren = toolbar.props.children;
            }

            // more than one toolbar option
            if (Array.isArray(toolbarChildren)) {
                toolbarOptions = toolbarChildren.filter(
                    (option) =>
                        option.type.displayName === "GridContainerToolbarOption"
                );
            }
            // only one toolbar option
            else if (toolbarChildren) {
                toolbarOptions =
                    toolbarChildren.type.displayName ===
                        "GridContainerToolbarOption"
                        ? [toolbarChildren]
                        : null;
            }
        }

        //let exportFilename = isEmpty(this.props.exportFilename) ? "data-export" : this.props.exportFilename;
        const csvFileName = this.props.csvFilename;
        const xlsxFileName = this.props.excelFilename;
        const showExportExcel = !isEmpty(this.props.excelFilename);
        const showExportCsv = !isEmpty(this.props.csvFilename);

        // properties to handle sorting
        let sortProperties = {};

        // properties to handle pagination
        let pageProperties = {};

        // properties to handle filtering
        let filterProperties = {};

        // properties to handle child table
        let childProperties = {};
        let data = this.props.data;

        const sortable = this.props.sortColumn !== undefined;
        const pageable = this.props.pageable;

        // set other properties required for grid functionality
        if (!isEmpty(this.props.data)) {
            // set the child component
            if (this.props.detail) {
                childProperties = {
                    expandField: "expanded",
                };
            }

            if (this.props.filterable) {
                filterProperties = {
                    filterable: true,
                    filter: this.state.filter,
                    onFilterChange: (e) => {
                        this.setState({
                            filter: e.filter,
                        });
                    },
                };
                data = filterBy(data, this.state.filter);
            }

            if (
                this.props.hasShowExcludedParts &&
                !this.state.showExcludedParts
            ) {
                //data = filterBy(data, {
                //    logic: "and",
                //    filters: [
                //        { field: "neverOrder", operator: "eq", value: false }
                //    ]
                //});
                data = filterBy(data, {
                    logic: "or",
                    filters: [
                        { field: "orderQuantity", operator: "neq", value: 0 },
                        {
                            field: "originalOrderQuantity",
                            operator: "neq",
                            value: 0,
                        },
                    ],
                });
            }
            //if (this.state.showExcludedPartsFilter) {
            //    data = filterBy(data, this.state.showExcludedPartsFilter);
            //}

            // do the sorting
            if (sortable) {
                sortProperties = {
                    sortable: true,
                    sort: this.state.sort,
                    onSortChange: (e) => {
                        this.setState({
                            sort: e.sort,
                        });
                    },
                };
                data = orderBy(data, this.state.sort);
            } else {
                //data = this.props.data;
            }

            //console.log("GridContainer render this.state.pageSize", this.state.pageSize);
            //console.log("GridContainer render this.state.take", this.state.take);
            // do the paging
            if (pageable) {
                let skip = this.state.skip;
                if (this.props.data.length <= skip) {
                    skip =
                        Math.floor(this.props.data.length / this.state.take) *
                        this.state.take;
                    if (this.props.data.length === skip) {
                        skip = this.props.data.length - this.state.take;
                    }
                    //this.setState({
                    //    skip: skip
                    //});
                }
                //else if (this.props.data.length = skip) {
                //    skip = this.props.data.length - this.state.skip;
                //    //this.setState({
                //    //    skip: skip
                //    //});
                //}

                pageProperties = {
                    pageable: {
                        buttonCount: this.props.buttonCount,
                        pageSizes: this.props.pageSizes !== null ? this.props.pageSizes : [5, 10, 20]
                    },
                    pageSize: this.state.pageSize,
                    skip: skip,
                    take: this.state.take,
                    total: this.props.data.length,
                    onPageChange: (e) => {
                        this.setState({
                            skip: e.page.skip,
                            take: e.page.take,
                            freshLoad: false,
                        });
                    },
                };

                data = data.slice(skip, this.state.take + skip);
                //console.log(`this.props.data.length: ${this.props.data.length}, skip: ${skip}, this.state.take: ${this.state.take}`);
            }
        }

        //{ this.props.hasShowExcludedParts && <ToolbarOption type="show-excluded-parts" showExcludedParts={this.state.showExcludedParts} handleClick={this.handleShowExcludedParts} /> }
        return (
            <LocalizationProvider language={this.props.uiLanguage}>
                <div className="position-relative" >
                    {
                        <Toolbar onTop={this.state.isNarrow} {...this.props}>
                            {showExportExcel && (
                                <ToolbarOption
                                    type="download-excel"
                                    handleClick={this.exportExcel}
                                />
                            )}
                            {showExportCsv && this.props.referenceID && (
                                <CSVLink
                                    data={this.props.csvData}
                                    filename={csvFileName}
                                    target="_self"
                                    onClick={() => {
                                        const updatedRecords =
                                            this.props.data.filter(
                                                (i) => i.updated
                                            );
                                        //console.log(updatedRecords);
                                        if ((this.props.allowUnsavedExcelExport === undefined || !this.props.allowUnsavedExcelExport) && updatedRecords.length > 0) {
                                            this.props.errorAlert("m0024");
                                            // If it returns an explicit false, the return will be interpreted as a claim to stop the click handling, then, the next logic will not be executed if so.
                                            return false;
                                        }
                                        this.props.postData(
                                            `/api/portal/admin/user/LogEvent/4/${this.props.referenceID}`
                                        );
                                    }}
                                >
                                    <ToolbarOption type="download-csv" />
                                </CSVLink>
                            )}
                            {showExportCsv && !this.props.referenceID && (
                                <CSVLink
                                    data={this.props.csvData}
                                    filename={csvFileName}
                                    target="_self"
                                    onClick={() => {
                                        const updatedRecords =
                                            this.props.data.filter(
                                                (i) => i.updated
                                            );
                                        //console.log(updatedRecords);
                                        if ((this.props.allowUnsavedExcelExport === undefined || !this.props.allowUnsavedExcelExport) && updatedRecords.length > 0) {
                                            this.props.errorAlert("m0024");
                                            // If it returns an explicit false, the return will be interpreted as a claim to stop the click handling, then, the next logic will not be executed if so.
                                            return false;
                                        }
                                    }}
                                >
                                    <ToolbarOption type="download-csv" />
                                </CSVLink>
                            )}
                            {!isEmpty(toolbarOptions) &&
                                toolbarOptions.map((option, index) => (
                                    <ToolbarOption key={index} {...option.props} />
                                ))}
                        </Toolbar>
                    }

                    {this.props.hasShowExcludedParts && (
                        <Toolbar onTop={true}>
                            <ToolbarOption
                                type="show-excluded-parts"
                                showExcludedParts={this.state.showExcludedParts}
                                handleClick={this.handleShowExcludedParts}
                            />
                        </Toolbar>
                    )}
                    <ExcelExport
                        ref={(exporter) => {
                            this._export = exporter;
                        }}
                        fileName={xlsxFileName}
                    >
                        <Grid
                            {...this.props}
                            {...filterProperties}
                            {...sortProperties}
                            {...pageProperties}
                            {...childProperties}
                            {...defaultGridProperties}
                            data={data}
                        ></Grid>
                    </ExcelExport>
                </div>
            </LocalizationProvider>
        );
    }
}

export default compose(localize, isPage)(GridContainer);



// WEBPACK FOOTER //
// ./src/components/GridContainer.js